import { useDroppable } from '@dnd-kit/core';
import classNames from 'classnames';
import type {
  EducationClass,
  ScheduleConstraintCategory,
  ScheduleErrorTimeslot,
  ScheduleLesson,
} from 'services/api';
import { LessonCard } from '../../LessonCard';
import styles from './styles.module.scss';

interface ScheduleCellProps {
  slotKey: string;
  isError: boolean;
  isSuggested?: boolean;
  item?: ScheduleLesson[];
  errorCategory?: ScheduleConstraintCategory;
  errors?: ScheduleErrorTimeslot[];
  educationalClass?: EducationClass;
}

export const ScheduleCell = ({
  slotKey,
  item,
  isSuggested,
  errorCategory,
  errors,
  educationalClass,
}: ScheduleCellProps) => {
  const { setNodeRef, isOver } = useDroppable({ id: slotKey });

  return (
    <div
      ref={setNodeRef}
      className={classNames(styles.cell, {
        [styles.cell_active]: isOver,
        [styles.cell_suggested]: isSuggested,
        [styles.cellError_logical]: errorCategory === 'LOGICAL',
        [styles.cellError_sanpin]: errorCategory === 'SANPIN',
      })}
    >
      {item?.map((lesson) => (
        <LessonCard
          key={lesson.id}
          lesson={lesson}
          slotKey={slotKey}
          errors={errors}
          educationalClass={educationalClass}
        />
      ))}
    </div>
  );
};
